import { Box, Chip, Divider, Typography, IconButton, Tooltip, CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import PropTypes from 'prop-types';
import { fetchWalletBalanceAsync } from 'redux/WalletSlice';
import { useDispatch } from 'react-redux';
import { useState } from 'react';

const BalanceChip = ({ heading, value, mode, color = 'primary' }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    // Handler for refresh button click
    const handleRefreshClick = (e) => {
        // Remove the "log;" which appears to be a typo
        e.stopPropagation(); // This prevents the parent click event from firing
        e.preventDefault(); // Additional prevention
        setIsLoading(true);
        dispatch(fetchWalletBalanceAsync())
            .then(() => {
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mr: 0.5,
                '&:hover': { cursor: 'pointer' }
            }}
        >
            <Chip
                className={mode === 'dark' ? 'goldenChip' : ''}
                color={color}
                size="small"
                sx={{
                    height: 'auto',
                    p: 0.5,
                    pr: 1.5, // Extra padding on right to accommodate the button
                    '&:hover': { cursor: 'pointer' },
                    position: 'relative'
                }}
                label={
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%'
                        }}
                    >
                        <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#fff' }}>
                            {heading}
                        </Typography>
                        <Divider sx={{ width: '100%', my: 0.25 }} />
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
                            <Typography sx={{ fontWeight: 'bold', color: '#fff' }} variant="body2">
                                ₹ {value || 0}
                            </Typography>
                            <Box
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                }}
                            >
                                <Tooltip title="Refresh balance">
                                    <IconButton
                                        size="small"
                                        onClick={handleRefreshClick}
                                        sx={{
                                            ml: 0.5,
                                            color: '#fff',
                                            '&:hover': {
                                                backgroundColor: 'rgba(255, 255, 255, 0.1)'
                                            },
                                            padding: '2px'
                                        }}
                                    >
                                        {isLoading ? (
                                            <CircularProgress size={16} thickness={5} sx={{ color: '#fff' }} />
                                        ) : (
                                            <RefreshIcon fontSize="small" />
                                        )}
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                    </Box>
                }
            />
        </Box>
    );
};

export default BalanceChip;

BalanceChip.propTypes = {
    heading: PropTypes.string,
    value: PropTypes.any,
    mode: PropTypes.string,
    color: PropTypes.string
};
